export default {"src":"/_next/static/media/onePagerIcon.f6cd0b7a.svg","height":20,"width":14};